const yandex = () => ({
  get: (text, fromLanguage, toLanguage) =>
    fetch(`${process.env.REACT_APP_YANDEX_API_URL}?key=${process.env.REACT_APP_YANDEX_API_KEY}&text=${encodeURIComponent(text)}&lang=${fromLanguage}-${toLanguage}`)
      .then(response => response.json())
})

export default yandex

